/**
 * Production public URLs (custom domain). Used in docs and optional server defaults.
 * Hosting may still run on Render; these are the user-facing origins.
 */
export const PRODUCTION_URLS = {
    marketing: 'https://disenchantments.org',
    app: 'https://app.disenchantments.org',
    api: 'https://api.disenchantments.org',
    gateway: 'https://gateway.disenchantments.org',
};
/** @deprecated Former Render static URL — do not use in new code or config. */
export const LEGACY_RENDER_APP_URL = 'https://disenchantment-frontend.onrender.com';
//# sourceMappingURL=urls.js.map